import { useEffect, useState,useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {createDeductionType, getDriverDeduction, getDriverDeductionByAll, getDriverDeductionById, getDriverDeductionSearch, updateDriverDeduction} from '../../../Services/Driver.service'
import { getCorporateClientsBySeviceCityIdAndTravelType, showAlert } from "../../../Services/Shared.service";
import SharedDataContext from "../../../_helper/SharedData";

export const DriverDeductionForm = ({isSearch, setIsSearch,setDriverDeductionType,driverScheme,newDriverSchemeFlow,handleBack}) => {

  // const [isSearch, setIsSearch] = useState(true);
  const [editId, setEditId] = useState(null);
  const[deductionList,setDeductionList]  = useState([]);
  const[isNew,setIsNew] = useState(false);
  const [selectedDeductionType,setselectedDeductionType] = useState({})
  const {setTabValue} = useContext(SharedDataContext);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch
  } = useForm({
    defaultValues: {},
  });

  const {CalculationType,DeductionType,DeductionName } = watch()


  // useEffect(()=>{
  //   if(editId !== null){
  //     const obj = {id:editId}
  //   getDriverDeductionById(obj).then((resp) =>{
  //     if(resp.status === 200){
  //       reset({
  //         CalculationType:{label:resp.data.calculateOn, value:resp.data.calculateOn},
  //         DeductionName:resp.data.deductionDisplayName,
  //         DeductionType:resp.data.deductionType,
  //       })
  //     }
  //   }).catch((err)=>{
  //     showAlert("error","Something went wrong")
  //   })
  //   }

  // },[selectedDeductionType])

 

  useEffect(() => {
    if (newDriverSchemeFlow == false && driverScheme.serviceCityId != null) {
      fetchDriverDeduction(driverScheme.id, driverScheme.serviceCityId);
    } else {
      fetchAllDriverDeduction();
    }
  }, []);

  const fetchDriverDeduction=(driverSchemeId,serviceCityId)=>{

    const obj ={
      serviceCityId:serviceCityId,
      driverTypeId:driverSchemeId
    }

    getDriverDeduction(obj).then((resp)=>{
      if(resp.status === 200){
        const data = []
        resp.data.searchResponse.forEach((element)=>{
          data.push({
            value: element,
            label: element.deductionType,
            id: element.id,
          })
        })
        setDeductionList(data)
      }
    })
  }

  const fetchAllDriverDeduction = () => {
    getDriverDeductionByAll()
      .then((resp) => {
        if (resp.status === 200) {
          const data = [];
          resp.data.searchResponse.forEach((element) => {
            data.push({
              value: element,
              label: element.deductionType,
              id: element.id,
            });
          });
          setDeductionList(data);
        }
      })
      .catch((err) => {
        console.log("getDriverDeductionByAll err: ", err);
      });
  };

  const handleDriverDeduction =(deductionType)=>{
    setselectedDeductionType(deductionType)
    setEditId(deductionType.id)
    setIsSearch(false)
  }

  // const getDriverDeductionOpt = async(inputValue)=>{
  //   let obj = {
  //     key:inputValue
  //   }

  //   if (inputValue.length) {
  //     return getDriverDeductionSearch(obj).then((result) => {
  //       const mappedArray = result.data.searchResponse.map((item) => ({
  //         value: item,
  //         label: item.deductionType,
  //       }));
  //       return mappedArray;
  //     });
  //   }
  // }



  const handleDeductionSubmit = (formValues) => {
    const body = {
      deductionType: formValues ? formValues.DeductionType : "",
      deductionDisplayName: formValues ? formValues.DeductionName : "",
      calculateOn:formValues?formValues.CalculationType.value:"",
    };
    
    
    if(editId){
      body["id"] = editId;
      updateDriverDeduction(body).then((resp)=>{
        setDriverDeductionType(resp.data)
        showAlert("success","Driver deduction type Updated")
        reset({
          CalculationType:null,
          DeductionName:"",
          DeductionType:"",
        })
        setEditId(null)
        setIsSearch(true)
        setTabValue(prev=>prev+1);
      }).catch((err)=>{
        showAlert("error","Something went wrong");
      }) 
    }else {
      createDeductionType(body).then((resp)=>{
        console.log("body of deduction",body)
        setDriverDeductionType(resp.data);
        showAlert("success","Driver deduction type created")
        reset({
        CalculationType:null,
        DeductionName:"",
        DeductionType:"",
      })
      setIsSearch(true)
      setTabValue(prev=>prev+1);
      }).catch((err)=>{
        showAlert("error","Something went wrong");
      })  
    }
  };

  const CalculationTypeArr = [
    { label: "BaseFare", value: "BaseFare" },
    { label: "TotalFare", value: "TotalFare" },
    { label: "WithAddCharge", value: "WithAddCharge" },
    { label: "None", value: "None" },
  ];



  const handleExistClick=(selectedDeduction)=>{
    console.log("selectedDeduction",selectedDeduction)
    setEditId(selectedDeduction.value.id)
    reset({

              DeductionName:selectedDeduction?selectedDeduction.value.deductionDisplayName:"",
              DeductionType:selectedDeduction?selectedDeduction.value.deductionType:"",
              CalculationType:selectedDeduction?CalculationTypeArr.find((item)=>
                item.value === selectedDeduction.value.calculateOn
                ):{label:"Select Calculation Type", value:""},
     })
     setIsSearch(false)

  }

//   useEffect(()=>{
//     reset({
//       CalculationType:selectedDeductionType?CalculationTypeArr.find((item)=>
//         item.value === selectedDeductionType.Value.calculateOn):{label:"Select Calculation Type", value:""}
// })
//   },[editId,CalculationTypeArr])

  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection:"column",
            gap:"1rem"
          }}
        >
          <div
            style={{
              width: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Button
              sx={{
                width: "100%",
                fontSize: "1rem",
                color: "#41CC7D",
                borderColor: "#41CC7D",
                "&:hover": {
                  borderColor: "#41CC7D",
                },
              }}
              variant="outlined"
              startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
              onClick={() => {
                setIsSearch(false);
                setIsNew(true);
              }}
            >
              New Deduction Type
            </Button>
            <Select
              placeholder={"Search Deduction Type"}
             options={deductionList}
            // loadOptions={getDriverDeductionOpt}
             onChange={handleExistClick}
            />
          </div>
          <button type="button"  className="btn submit-button" onClick={()=>handleBack()}>Back</button>
        </div>
      ) : (
        <Form onSubmit={handleSubmit(handleDeductionSubmit)}>
          <Row>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Deduction type</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("DeductionType", {
                    required: {
                      value: true,
                      message: "DeductionType is required",
                    },
                    onChange: (e) => {
                      setValue("DeductionType", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.DeductionType?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">
                Deduction display Name
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("DeductionName", {
                    required: {
                      value: true,
                      message: "DeductionName is required",
                    },
                    onChange: (e) => {
                      setValue("DeductionName", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.DeductionName?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">
                Calculation Type
              </Label>
              <Col lg="12">
                <Select
                  options={CalculationTypeArr}
                  value={CalculationType}
                  placeholder={"Select Calculation Type"}
                  isSearchable={false}
                {...register("CalculationType",{
                  required: {
                    value: true,
                    message: "CalculationType is required",
                  },
                })}
                onChange={(e)=>setValue("CalculationType",e)
                }
                />
                <span style={{ color: "red" }}>
                  {errors?.CalculationType?.message}
                </span>
              </Col>
            </FormGroup>
           {/* <button type="button" onClick={()=>setIsSearch(true)}>Back</button> */}
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              gap:"1rem"
            }}
          >
            <button type="button"  className="btn submit-button" onClick={()=>setIsSearch(true)}>Back</button>
            <button type="submit" className="btn submit-button">
              {"Next"}
            </button>
            
          </div>

        </Form>
      )}
       
    </div>
  );
};